<template>
    <textarea id="ContentEditor" v-model="value"></textarea>
    <!--    <vue-editor v-model="value" ></vue-editor>-->
</template>

<script>
    // import Editor from '@tinymce/tinymce-vue'
    // import { VueEditor } from "vue2-editor";
    export default {
        props: {
            value: {
                type: String,
                default: '<p></p>'
            }
        },
        name: "ContentEditor",
        components: {
            // VueEditor
        },
        mounted() {
            tinymce.init({
                selector: '#ContentEditor',
                language_url: 'langs/zh_CN.js',
                plugins: 'code table image',
                height: "180mm",
                images_upload_url: 'http://localhost:8090/api/doc/uploadImage',
              //  images_upload_base_path: 'api',
                fontsize_formats: "8pt 9pt 10pt 11pt 12pt 16pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
                content_style: "body { line-height: 28pt;font-size:16pt;font-family: 方正仿宋简体; }p { margin: 0; }",
                font_formats: '仿宋_GB2312;楷体_GB2312;黑体;方正小宋标简体;Times New Roman',
                toolbar: "bold italic underline strikethrough | fontsizeselect fontselect | alignleft aligncenter alignright alignjustify | bullist numlist  |table image code|",
                statusbar: false,
                language: 'zh_CN',
                menubar: false
            });
        },
        methods: {
            getContent() {
                return tinymce.get("ContentEditor").getContent();
            }
        }
    }
</script>